import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

/* const ICONS = {
  setting: icon('ic_product'),
  contributor: icon('ic_calendar'),
  archive: icon('ic_disabled'),
  quiz: icon('ic_external'),
  trainee: icon('ic_user'),
  trainingrequest: icon('ic_menu_item'),
  training: icon('ic_ecommerce'),
  plannification: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};
 */

const ICONS = {
  setting: icon('gear'),
  contributor: icon('person'),
  archive: icon('archive'),
  quiz: icon('textarea-resize'),
  trainee: icon('people'),
  trainingrequest: icon('layout-text-sidebar-reverse'),
  training: icon('list-task'),
  plannification: icon('grid-1x2'),
  dashboard: icon('house'),
  document: icon('document-sign'),
  builder: icon('ic_kanban'),
  accessLogs: icon('ic_lock'),
  program: icon('si_book_line'),

  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();

  const dataOrganizations = useMemo(
    () => [
      {
        items: [
          {
            title: t('Tableau de Bord'),
            path: paths.dashboardOld,
            icon: ICONS.dashboard,
          },
        ],
      },
      {
        items: [
          {
            title: t('Planification'),
            path: paths.plannification,
            icon: ICONS.plannification,
          },
        ],
      },
      {
        items: [
          {
            title: t('Sessions de formation'),
            path: paths.training,
            icon: ICONS.training,
          },
        ],
      },
      {
        items: [
          {
            title: t('Demandes de formation'),
            path: paths.trainingrequest,
            icon: ICONS.trainingrequest,
          },
        ],
      },
      {
        items: [
          {
            title: t('Quiz'),
            path: paths.formlist,
            icon: ICONS.quiz,
            children: [
              { title: t('Formulaires'), path: paths.formlist },
              { title: t('Statistiques'), path: paths.statisticList },
            ],
          },
        ],
      },
      {
        items: [
          {
            title: t('Documents'),
            path: paths.documentList,
            icon: ICONS.document,
          },
        ],
      }, 
      {
        items: [
          {
            title: t('Programmes'),
            path: paths.program,
            icon: ICONS.program,
          },
        ],
      }, 
      {
        items: [
          {
            title: t('Stagiaires'),
            path: paths.trainee,
            icon: ICONS.trainee,
          },
        ],
      },
      {
        items: [
          {
            title: t('Intervenants'),
            path: paths.contributor,
            icon: ICONS.contributor,
          },
        ],
      }, 
      {
        items: [
          {
            title: t('Site'),
            path: paths.builder,
            icon: ICONS.builder,
          },
        ],
      },
      {
        items: [
          {
            title: t('Archives'),
            path: paths.archive,
            icon: ICONS.archive,
          },
        ],
      },
      {
        items: [
          {
            title: t('Paramètres'),
            path: paths.setting,
            icon: ICONS.setting,
          },
        ],
      },
    ],
    [t]
  );

  return dataOrganizations;
}

export function useNavDataTrainees() {
  const { t } = useLocales();

  const dataTrainees = useMemo(
    () => [
      {
        items: [
          {
            title: t('Sessions de formation'),
            path: paths.trainingTrainees,
            icon: ICONS.training,
          },
        ],
      },
      {
        items: [
          {
            title: t('Quiz'),
            path: paths.formlistTrainee,
            icon: ICONS.quiz,
          },
        ],
      },
      {
        items: [
          {
            title: t('Documents'),
            path: paths.documentListTrainee,
            icon: ICONS.document,
          },
        ],
      },
      // {
      //   items: [
      //     {
      //       title: t('parametre'),
      //       path: paths.organizationNewPath,
      //       icon: ICONS.setting,
      //     },
      //   ],
      // },
    ],
    [t]
  );

  return dataTrainees;
}

export function useNavDataAdmin() {
  const { t } = useLocales();

  const dataTrainees = useMemo(
    () => [
      {
        items: [
          {
            title: t('Abonnements'),
            path: paths.dashboardAdministration,
            icon: ICONS.training,
          },
        ],
      },
      {
        items: [
          {
            title: t('Organismes'),
            path: paths.user,
            icon: ICONS.contributor,
          },
        ],
      },
      {
        items: [
          {
            title: t('Authentication'),
            path: paths.accessLogs,
            icon: ICONS.accessLogs,
          },
        ],
      },
      {
        items: [
          {
            title: t('Factures'),
            path: paths.invoice,
            icon: ICONS.invoice,
          },
        ],
      },
      {
        items: [
          {
            title: t('Connexion Api'),
            path: paths.apiToken,
            icon: ICONS.external,
          },
        ],
      },
    ],
    [t]
  );

  return dataTrainees;
  
}

export function useNavDataManager() {
  const { t } = useLocales();

  const dataManager = useMemo(
    () => [
      {
        items: [
          {
            title: t('Planification'),
            path: paths.plannification,
            icon: ICONS.plannification,
          },
        ],
      },
      {
        items: [
          {
            title: t('Sessions de formation'),
            path: paths.training,
            icon: ICONS.training,
          },
        ],
      },
      {
        items: [
          {
            title: t('Demandes de formation'),
            path: paths.trainingrequest,
            icon: ICONS.trainingrequest,
          },
        ],
      }, 
      {
        items: [
          {
            title: t('Archives'),
            path: paths.archive,
            icon: ICONS.archive,
          },
        ],
      },
    ],
    [t]
  );

  return dataManager;
}